export const _en = {
    dischargeDate: {
        label: "Discharged on"
    },
    userUid: {
        label: "By"
    },
    currentStatus: {
        label: "Status"
    },
    commentary: {
        label: "Comment"
    }
};

export const _fr = {
    dischargeDate: {
        label: "Acquittée le"
    },
    userUid: {
        label: "Par"
    },
    currentStatus: {
        label: "Statut"
    },
    commentary: {
        label: "Commentaire"
    }
};